module.exports = __webpack_public_path__ + "static/media/checkmarkIcon.4d468387.svg";